import myplan from "@/services/my.plan";
import notification from "@/services/notification";

export default {
    namespaced: true,
    state: {
        loading: false,
        errors: null,
        plan: null,
        billingHistory: null,
        tabs: [
            {
                name: "Plan Details",
                href: "/my-plan/details",
                access: "my-plan.plan-details",
                enabled: true
            },
            {
                name: "Billing History",
                href: "/my-plan/billing-history",
                access: "my-plan.plan-billing-history",
                enabled: true
            },
            {
                name: "Payout History",
                href: "/my-plan/payout-history",
                access: "my-plan.plan-billing-history",
                enabled: true
            }
        ],
        payoutHistory: null,
        payoutReceivedSummary: null,
        payoutHistoryLoading: false,
    },
    getters: {
        loading: state => state.loading,
        errors: state => state.errors,
        plan: state => state.plan,
        computationBreakdown: state => {
            const { plan } = state;

            if (plan) {
                if (
                    plan.billing_recurrence === "monthly" &&
                    plan.monthly_breakdown
                )
                    return plan.monthly_breakdown;

                if (
                    plan.billing_recurrence === "yearly" &&
                    plan.annual_breakdown
                )
                    return plan.annual_breakdown;

                if (
                    plan.billing_recurrence === "quarterly" &&
                    plan.quarterly_breakdown
                )
                    return plan.quarterly_breakdown;

                if (
                    plan.billing_recurrence === "bi-annual" &&
                    plan.bi_annual_breakdown
                )
                    return plan.bi_annual_breakdown;
            }

            return null;
        }
    },
    mutations: {
        setLoading(state, value) {
            state.loading = value;
        },
        setErrors(state, errors) {
            state.errors = errors;
        },
        setPlan(state, plan) {
            if (plan) {
                if (plan.plan_uuid === null) {
                    plan.plan_name = "Professional Plan";
                    plan.billing_recurrence = "-";
                }
            }
            state.plan = plan;
        },
        setBillingHistory(state, payload) {
            state.billingHistory = payload;
        },
        setTabs(state, payload) {
            state.tabs = payload;
        },
        setPayoutReceivedSummary(state, value) {
            state.payoutReceivedSummary = value;
        },
        setPayoutHistory(state, value) {
            state.payoutHistory = value;
        },
        setPayoutHistoryLoading(state, value) {
            state.payoutHistoryLoading = value;
        }
    },
    actions: {
        async getPlanDetails({ commit }) {
            commit("setLoading", true);
            try {
                const { data } = await myplan.getPlanDetails();
                commit("setPlan", data);
            } catch (errors) {
                commit("setErrors", errors);
            } finally {
                commit("setLoading", false);
            }
        },
        async cancelSubscription({ commit }, payload) {
            commit("setLoading", true);
            try {
                await myplan.cancelSubscription(payload);
                notification.success("Thank you for your feedback.");
            } catch (errors) {
                commit("setErrors", errors);
            } finally {
                commit("setLoading", false);
            }
        },
        async savePaymentMethod({ commit }, payload) {
            commit("setLoading", true);
            try {
                const { message } = await myplan.savePaymentMethod(payload);
                notification.success(message);
            } catch (errors) {
                commit("setErrors", errors);
            } finally {
                commit("setLoading", false);
            }
        },
        async removePaymentMethod({ commit }, payload) {
            commit("setLoading", true);
            try {
                const { message } = await myplan.removePaymentMethod(payload);
                notification.success(message);
            } catch (errors) {
                commit("setErrors", errors);
            } finally {
                commit("setLoading", false);
            }
        },
        async makePrimaryPaymentMethod({ commit }, payload) {
            commit("setLoading", true);
            try {
                const { message } = await myplan.makePrimaryPaymentMethod(
                    payload
                );
                notification.success(message);
            } catch (errors) {
                commit("setErrors", errors);
            } finally {
                commit("setLoading", false);
            }
        },
        getBillingHistory: async ({ commit }, payload) => {
            commit("setLoading", true);

            try {
                const response = await myplan.getBillingHistory(payload);

                commit("setBillingHistory", response);
            } catch (errors) {
                commit("setErrors", errors);
            } finally {
                commit("setLoading", false);
            }
        },
        uploadProofOfPayment({ commit }, payload) {
            return myplan.uploadProofOfPayment(payload);
        },
        getPayoutReceivedSummary: async ({ commit }) => {
            commit("setLoading", true);
            commit("setPayoutReceivedSummary", null);

            try {
                const { data } = await myplan.getPayoutReceivedSummary();

                commit("setPayoutReceivedSummary", data);
            } catch (errors) {
                commit("setErrors", errors);
            } finally {
                commit("setLoading", false);
            }
        },
        getPayoutHistory: async ({ commit }, page = 1) => {
            commit("setPayoutHistoryLoading", true);
            commit("setPayoutHistory", null);
            try {
                const { data, max_page, no_of_rows } = await myplan.getPayoutHistory(page);
                commit("setPayoutHistory", { data, max_page, current_page: page, no_of_rows });
            } catch (errors) {
                commit("setErrors", errors);
            } finally {
                commit("setPayoutHistoryLoading", false);
            }
        },
    }
};
